"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var Observable_1 = require("rxjs/Observable");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var Subject_1 = require("rxjs/Subject");
var SisHintSettingsComponent = /** @class */ (function () {
    function SisHintSettingsComponent(languageService, currentLanguageProvider) {
        this.languageService = languageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.valueChange = new core_1.EventEmitter();
        this.isReady = false;
        this.ngUnsubscribe = new Subject_1.Subject();
    }
    SisHintSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        Observable_1.Observable.zip(this.languageService.getInputLanguages(), this.currentLanguageProvider.getCurrentLanguage())
            .takeUntil(this.ngUnsubscribe)
            .subscribe(function (data) {
            _this.languages = data[0];
            _this.currentLanguageId = data[1].getId();
            if (!_this.hint) {
                _this.hint = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder()
                    .withValueForLanguages(_this.languages.map(function (language) { return language.getId(); }), '')
                    .build();
            }
            _this.isReady = true;
            setTimeout(function () {
                return _this.hintInput.registerOnChange(function (hint) { return _this.valueChange.emit(hint); });
            }, 10);
        });
    };
    SisHintSettingsComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SisHintSettingsComponent.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-portfolio-hint-setting',
                    styles: [require('./sis-hint-settings.component.css')],
                    template: require('./sis-hint-settings.component.html')
                },] },
    ];
    /** @nocollapse */
    SisHintSettingsComponent.ctorParameters = function () { return [
        { type: idm_message_language_service_client_js_1.LanguageService, },
        { type: idm_session_data_provider_api_js_1.CurrentLanguageProvider, },
    ]; };
    SisHintSettingsComponent.propDecorators = {
        "hint": [{ type: core_1.Input },],
        "valueChange": [{ type: core_1.Output },],
        "hintInput": [{ type: core_1.ViewChild, args: ['hintInput',] },],
    };
    return SisHintSettingsComponent;
}());
exports.SisHintSettingsComponent = SisHintSettingsComponent;
//# sourceMappingURL=sis-hint-settings.component.js.map